// src/components/Service.js
import axios from 'axios';

const API_URL = 'https://crmapitest4.onrender.com/api/v1/expenses';

// جلب المعاملات النشطة فقط (isActive = true)
export const getAllTransactions = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.type) params.append('type', filters.type);
    if (filters.category) params.append('category', filters.category);
    if (filters.paymentmethod) params.append('paymentmethod', filters.paymentmethod);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit || 10);
    
    const response = await axios.get(`${API_URL}?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching transactions:', error);
    throw error;
  }
};

// جلب جميع المعاملات (بما فيها المحذوفة) - isActive = true + false
export const getAllTransactionsWithDeleted = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.type) params.append('type', filters.type);
    if (filters.category) params.append('category', filters.category);
    if (filters.paymentmethod) params.append('paymentmethod', filters.paymentmethod);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit || 10);
    
    const response = await axios.get(`${API_URL}/all-with-deleted?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all transactions:', error);
    throw error;
  }
};

// جلب المعاملات المحذوفة فقط (isActive = false)
export const getDeletedTransactions = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.type) params.append('type', filters.type);
    if (filters.category) params.append('category', filters.category);
    if (filters.paymentmethod) params.append('paymentmethod', filters.paymentmethod);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit || 10);
    
    const response = await axios.get(`${API_URL}/deleted?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching deleted transactions:', error);
    throw error;
  }
};

// إنشاء معاملة جديدة
export const createTransaction = async (data) => {
  try {
    const response = await axios.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error('Error creating transaction:', error);
    throw error;
  }
};

// تحديث معاملة
export const updateTransaction = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating transaction:', error);
    throw error;
  }
};

// حذف معاملة واحدة (Soft Delete)
export const deleteTransaction = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting transaction:', error);
    throw error;
  }
};

// حذف معاملات متعددة (Soft Delete)
export const deleteMultipleTransactions = async (ids) => {
  try {
    const response = await axios.post(`${API_URL}/delete-multiple`, { ids });
    return response.data;
  } catch (error) {
    console.error('Error deleting multiple transactions:', error);
    throw error;
  }
};

// استعادة معاملة واحدة محذوفة
export const restoreTransaction = async (id) => {
  try {
    const response = await axios.put(`${API_URL}/restore/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error restoring transaction:', error);
    throw error;
  }
};

// استعادة معاملات متعددة محذوفة
export const restoreMultipleTransactions = async (ids) => {
  try {
    const response = await axios.post(`${API_URL}/restore-multiple`, { ids });
    return response.data;
  } catch (error) {
    console.error('Error restoring multiple transactions:', error);
    throw error;
  }
};

// جلب الإحصائيات
export const getStatistics = async () => {
  try {
    const response = await axios.get(`${API_URL}/statistics`);
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    throw error;
  }
};

// تصدير التقرير
export const exportReport = async (filters) => {
  try {
    const params = new URLSearchParams();
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.type) params.append('type', filters.type);
    if (filters.category) params.append('category', filters.category);
    if (filters.paymentmethod) params.append('paymentmethod', filters.paymentmethod);
    if (filters.status) params.append('status', filters.status);
    
    const response = await axios.get(`${API_URL}/export?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error exporting report:', error);
    throw error;
  }
};